import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    if (response.ok) {
      setSubmitted(true);
      form.reset();
    }
  };

  return (
    <section id="contact" className="contact-section" data-aos="fade-up">
      <div className="contact-container">
        <h1 className="contact-heading">Contact Us</h1>
        <p className="contact-subheading">Any questions or remarks? Just write us a message!</p>

        {/* Success message */}
        {submitted && (
          <div className="success-message" data-aos="fade-up">
            Thanks for contacting us, Your response was sent successfully!
          </div>
        )}

        {/* Contact Form with Web3Forms */}
        <form onSubmit={handleSubmit} className="contact-form" data-aos="fade-up">
          <input type="hidden" name="access_key" value="ff1c17dd-8a36-465a-a352-b401b0599ae0" />

          <input
            type="text"
            name="name"
            placeholder="Enter your Name"
            className="contact-input"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Enter a valid email address"
            className="contact-input"
            required
          />
          <textarea
            name="message"
            placeholder="Your Message to Us"
            rows="4"
            className="contact-textarea"
            required
          ></textarea>

          <button type="submit" className="contact-submit-button">SUBMIT</button>
        </form>

        {/* Contact Info Section */}
        <div className="contact-info-grid" data-aos="fade-up">
          {/* Email Us */}
          <div className="contact-info-item">
            <div className="icon-circle">
              <svg viewBox="0 0 24 24">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
            </div>
            <h3 className="contact-info-heading">Email Us</h3>
            <p className="contact-info-text">info@ak-tech.in</p>
          </div>

          {/* Call Us */}
          <div className="contact-info-item">
            <div className="icon-circle">
              <svg viewBox="0 0 24 24">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.12.35.03.74-.24 1.02l-2.2 2.2z"/>
              </svg>
            </div>
            <h3 className="contact-info-heading">Call Us</h3>
            <p className="contact-info-text">Phone: +91 8925531013 (Preferred)</p>
            <p className="contact-info-text">Landline: +0422 2992101</p>
          </div>

          {/* Reach Us */}
          <div className="contact-info-item">
            <div className="icon-circle">
              <svg viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5z"/>
              </svg>
            </div>
            <h3 className="contact-info-heading">Reach Us</h3>
            <div className="contact-addresses">
              <div className="contact-address-item">
                
                <p className="contact-address-text">
                  PSG - Science and Technology Entrepreneurial Park (PSG-STEP),<br />
                  E8 Block, PSG iTECH Campus, Neelambur,<br />
                  Coimbatore, Tamil Nadu - 641 062
                </p>
              </div>
              <div className="contact-address-item">
                <p className="contact-address-text">
                  113, B1 Block, Karayampalayam Road,<br />
                  Mylampatti, Chinniyampalayam,<br />
                  Coimbatore, Tamil Nadu - 641 062
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;